import React from 'react'
import "../assets/css/footer.css"

const Footer = () => (
    <div id="footer">
        <h2 className="footer-title">Lojas Propz</h2>
        <ul>
            <li>Belo Horizonte</li>
            <li>CAmpinas</li>
            <li>São Paulo</li>
            <li>Rio de Janeiro</li>
        </ul>
    </div>
)

export default Footer
